'use client'

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { useLIFF } from '@/lib/liff/context'

export function NavUser() {
  const { profile, decodedIdToken } = useLIFF()

  // return (
  //   <SidebarMenu>
  //     <SidebarMenuItem>
  //       <DropdownMenu>
  //         <DropdownMenuTrigger
  //           render={
  //             <SidebarMenuButton
  //               size="lg"
  //               className="aria-expanded:bg-muted"
  //             />
  //           }
  //         >
  //           <Avatar>
  //             <AvatarImage
  //               src={profile?.pictureUrl}
  //               alt={profile?.displayName}
  //             />
  //             <AvatarFallback>
  //               {profile?.displayName?.charAt(0).toUpperCase()}
  //             </AvatarFallback>
  //           </Avatar>
  //           <div className="grid flex-1 text-left text-sm leading-tight">
  //             <span className="truncate font-medium">
  //               {profile?.displayName}
  //             </span>
  //             <span className="truncate text-xs">{user.email}</span>
  //           </div>
  //           <ChevronsUpDownIcon className="ml-auto size-4" />
  //         </DropdownMenuTrigger>
  //         <DropdownMenuContent
  //           className="min-w-56 rounded-lg"
  //           side={isMobile ? 'bottom' : 'right'}
  //           align="end"
  //           sideOffset={4}
  //         >
  //           <DropdownMenuGroup>
  //             <DropdownMenuLabel className="p-0 font-normal">
  //               <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
  //                 <Avatar>
  //                   <AvatarImage
  //                     src={user.avatar}
  //                     alt={user.name}
  //                   />
  //                   <AvatarFallback>CN</AvatarFallback>
  //                 </Avatar>
  //                 <div className="grid flex-1 text-left text-sm leading-tight">
  //                   <span className="truncate font-medium">{user.name}</span>
  //                   <span className="truncate text-xs">{user.email}</span>
  //                 </div>
  //               </div>
  //             </DropdownMenuLabel>
  //           </DropdownMenuGroup>
  //           <DropdownMenuSeparator />
  //           <DropdownMenuGroup>
  //             <DropdownMenuItem>
  //               <SparklesIcon />
  //               Upgrade to Pro
  //             </DropdownMenuItem>
  //           </DropdownMenuGroup>
  //           <DropdownMenuSeparator />
  //           <DropdownMenuGroup>
  //             <DropdownMenuItem>
  //               <BadgeCheckIcon />
  //               Account
  //             </DropdownMenuItem>
  //             <DropdownMenuItem>
  //               <CreditCardIcon />
  //               Billing
  //             </DropdownMenuItem>
  //             <DropdownMenuItem>
  //               <BellIcon />
  //               Notifications
  //             </DropdownMenuItem>
  //           </DropdownMenuGroup>
  //           <DropdownMenuSeparator />
  //           <DropdownMenuItem>
  //             <LogOutIcon />
  //             Log out
  //           </DropdownMenuItem>
  //         </DropdownMenuContent>
  //       </DropdownMenu>
  //     </SidebarMenuItem>
  //   </SidebarMenu>
  // )

  return (
    <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
      <Avatar>
        <AvatarImage
          src={profile?.pictureUrl}
          alt={profile?.displayName}
        />
        <AvatarFallback>
          {profile?.displayName?.charAt(0).toUpperCase()}
        </AvatarFallback>
      </Avatar>
      <div className="grid flex-1 text-left text-sm leading-tight">
        <span className="truncate font-medium">{profile?.displayName}</span>
        {decodedIdToken?.email && (
          <span className="truncate text-xs">{decodedIdToken.email}</span>
        )}
      </div>
    </div>
  )
}
